module.exports = __webpack_public_path__ + "static/media/snapshift-2.68dc0f04.png";